import { render } from "./MarketsDropdown.vue?vue&type=template&id=cf7fcf78&ts=true"
import script from "./MarketsDropdown.vue?vue&type=script&lang=ts"
export * from "./MarketsDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__